import ModalContext from './context'
const ModalConsumer = ModalContext.Consumer;
export default ModalConsumer;